(function () {
  'use strict';

  if (window.GlossyCart) return;

  var shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  var themeRoot = window.theme && window.theme.routes && window.theme.routes.root_url;
  var root = shopifyRoot || themeRoot || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var recentAddStorageKey = 'glossy-cart-recent-add';
  var buyNowSnapshotStorageKey = 'glossy-buy-now-cart-snapshot';
  var buyNowSnapshotMaxAge = 60 * 60 * 1000;

  var messages = {
    added: 'Item added to cart',
    addError: 'Unable to add this item. Please try again.',
    updateError: 'Unable to update your cart. Please try again.',
    offline: "You're offline. Check your connection and try again.",
    selectVariant: 'Please select an available option.',
    maxAvailable: 'Maximum Available Quantity Reached',
    viewCart: 'View Cart'
  };

  var state = {
    cart: readInitialCart(),
    inventory: readInitialInventory(),
    cartRequest: null,
    cartRequestEpoch: null,
    cartRequestRevision: null,
    pendingAdds: [],
    pendingChanges: {},
    pendingSequence: 0,
    mutationEpoch: 0,
    canonicalRevision: 0,
    activeCurrency: readActiveCurrency(),
    currencyOverride: '',
    latestCartPageSection: '',
    toastTimer: null,
    recommendationAddsInFlight: 0,
    recommendationWave: 0,
    recommendationRefreshRequest: null,
    recentAddRecheckTimer: null,
    currencyRefreshTimer: null,
    lastTimeoutToastAt: 0,
    cartProcessingVisible: false,
    queuedCheckout: null,
    checkoutNavigationStarted: false,
    pendingBuyNowRestore: null
  };
  var checkoutSelector = '.custom-cart-drawer__checkout, .cart__checkout, [name="checkout"], .additional-checkout-buttons, [data-shopify-buttoncontainer]';
  var expressCheckoutSelector = '.additional-checkout-buttons, [data-shopify-buttoncontainer]';

  function route(path) {
    return root + String(path || '').replace(/^\//, '');
  }

  function parseJson(text) {
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      return null;
    }
  }

  function readRecentAddTime() {
    try {
      if (window.sessionStorage) sessionStorage.removeItem('glossy-cart-navigation-sync');
      var savedAt = parseInt(window.sessionStorage && sessionStorage.getItem(recentAddStorageKey), 10) || 0;
      if (!savedAt || Date.now() - savedAt > 10000) {
        if (window.sessionStorage) sessionStorage.removeItem(recentAddStorageKey);
        return 0;
      }
      return savedAt;
    } catch (storageError) {
      return 0;
    }
  }

  function markRecentAdd() {
    try {
      if (window.sessionStorage) sessionStorage.setItem(recentAddStorageKey, String(Date.now()));
    } catch (storageError) {}
  }

  function clearRecentAdd() {
    try {
      if (window.sessionStorage) sessionStorage.removeItem(recentAddStorageKey);
    } catch (storageError) {}
  }

  function clearBuyNowSnapshot() {
    try {
      if (window.sessionStorage) sessionStorage.removeItem(buyNowSnapshotStorageKey);
    } catch (storageError) {}
  }

  function readInitialCart() {
    var element = document.getElementById('glossy-cart-initial-state');
    var cart = element ? parseJson(element.textContent) : null;
    return cart && cart.items ? cart : null;
  }

  function readInitialInventory() {
    var element = document.querySelector('[data-glossy-cart-inventory]');
    var inventory = element ? parseJson(element.textContent) : null;
    return inventory || {};
  }

  function readActiveCurrency() {
    var selector = document.querySelector('[name="doubly-currencies"]');
    if (selector && selector.value) return selector.value;
    var convertedMoney = document.querySelector('.money[doubly-currency]');
    return convertedMoney && convertedMoney.getAttribute('doubly-currency') || window.shopCurrency || '';
  }

  function stateFromSection(html) {
    if (!html) return null;
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var cartElement = holder.querySelector('[data-glossy-cart-state]');
    var inventoryElement = holder.querySelector('[data-glossy-cart-inventory]');
    var cart = cartElement ? parseJson(cartElement.textContent) : null;
    var inventory = inventoryElement ? parseJson(inventoryElement.textContent) : null;
    return cart && cart.items ? { cart: cart, inventory: inventory || {} } : null;
  }

  function createCartError(response, data) {
    data = data || {};
    var error = new Error(data.description || data.message || (response && response.statusText) || messages.updateError);
    error.name = 'GlossyCartError';
    error.status = response ? response.status : 0;
    error.data = data;
    return error;
  }

  function requestJson(path, options) {
    return fetch(route(path), options || {}).then(function (response) {
      return response.text().then(function (text) {
        var data = parseJson(text) || {};
        if (!response.ok || data.status === 422 || data.status === 'bad_request') {
          throw createCartError(response, data);
        }
        return data;
      });
    });
  }

  function showMutationTimeoutWarning() {
    if (Date.now() - state.lastTimeoutToastAt < 2000) return;
    state.lastTimeoutToastAt = Date.now();
    showToast({
      message: 'Cart update is still processing. Please check your cart.',
      type: 'error',
      actionLabel: messages.viewCart,
      actionUrl: route('cart'),
      duration: 7000
    });
  }

  function dispatch(name, detail) {
    var event;
    try {
      event = new CustomEvent(name, { detail: detail || {} });
    } catch (error) {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, false, false, detail || {});
    }
    document.dispatchEvent(event);
  }

  function isDutiesItem(item) {
    var title = item && (item.product_title || item.title) || '';
    return title.toLowerCase().indexOf('additional') !== -1;
  }

  function visibleItems(cart) {
    var items = [];
    if (!cart || !cart.items) return items;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isDutiesItem(cart.items[i])) items.push(cart.items[i]);
    }
    return items;
  }

  function visibleItemCount(cart) {
    var count = 0;
    var items = visibleItems(cart);
    for (var i = 0; i < items.length; i++) count += parseInt(items[i].quantity, 10) || 0;
    return count;
  }

  function currentCurrency() {
    if (state.currencyOverride) return state.currencyOverride;
    var selector = document.querySelector('[name="doubly-currencies"]');
    if (selector && selector.value) state.activeCurrency = selector.value;
    return state.activeCurrency || window.shopCurrency || 'AED';
  }

  function formatMoney(cents) {
    var amount = Math.max(Math.round(Number(cents) || 0), 0);
    var sourceCurrency = window.shopCurrency || 'AED';
    var activeCurrency = currentCurrency();
    var converter = window.DoublyGlobalCurrency;
    if (converter && typeof converter.convert === 'function' && typeof converter.formatMoney === 'function' && converter.moneyFormats) {
      try {
        var formats = converter.moneyFormats[activeCurrency];
        var activeFormat = formats && formats[converter.format];
        var convertedAmount = sourceCurrency === activeCurrency
          ? amount
          : Math.round(converter.convert(amount / 100, sourceCurrency, activeCurrency) * 100);
        if (activeFormat && isFinite(convertedAmount)) return converter.formatMoney(convertedAmount, activeFormat);
      } catch (conversionError) {}
    }
    if (window.slate && window.slate.Currency && window.moneyFormat) {
      return window.slate.Currency.formatMoney(amount, window.moneyFormat);
    }
    return 'Dhs. ' + (amount / 100).toFixed(2);
  }

  function moneyMarkup(cents) {
    var formatted = formatMoney(cents);
    return /class=["'][^"']*\bmoney\b/.test(formatted) ? formatted : '<span class="money">' + formatted + '</span>';
  }

  function stampMoney(element, cents, cart) {
    if (!element) return;
    var money = element.classList && element.classList.contains('money') ? element : element.querySelector && element.querySelector('.money');
    if (!money) return;
    var currency = cart && cart.currency || window.shopCurrency || 'AED';
    money.setAttribute('doubly-currency-' + String(currency).toLowerCase(), Math.max(Math.round(Number(cents) || 0), 0));
    money.setAttribute('doubly-currency', currentCurrency() || currency);
  }

  function convertActiveCurrency(currency) {
    if (!window.DoublyCurrency || typeof window.DoublyCurrency.convertAll !== 'function' || !window.jQueryGrizzly) return;
    var selector = document.querySelector('[name="doubly-currencies"]');
    if (currency) state.activeCurrency = currency;
    else if (selector && selector.value) state.activeCurrency = selector.value;
    var activeCurrency = state.activeCurrency || window.shopCurrency;
    if (activeCurrency) window.DoublyCurrency.convertAll(activeCurrency);
  }

  function scheduleCartCurrencyRefresh(currency) {
    if (!document.querySelector('#custom-cart-drawer, [data-glossy-cart-page]')) return;
    if (currency) {
      state.activeCurrency = currency;
      state.currencyOverride = currency;
    }
    if (state.currencyRefreshTimer) clearTimeout(state.currencyRefreshTimer);
    state.currencyRefreshTimer = setTimeout(function () {
      state.currencyRefreshTimer = null;
      var cart = projectCart();
      try { syncDrawer(cart); } catch (drawerError) {}
      try { syncCartPage(cart); } catch (cartPageError) {}
      try {
        var sourceCurrency = String(window.shopCurrency || 'AED').toLowerCase();
        var recommendationPrices = document.querySelectorAll('#custom-cart-drawer .cart-rec-item__price .money[doubly-currency-' + sourceCurrency + ']');
        for (var i = 0; i < recommendationPrices.length; i++) {
          var cents = recommendationPrices[i].getAttribute('doubly-currency-' + sourceCurrency);
          recommendationPrices[i].innerHTML = formatMoney(cents);
          recommendationPrices[i].setAttribute('doubly-currency', currentCurrency());
        }
      } catch (recommendationCurrencyError) {}
      try { convertActiveCurrency(currency); } catch (currencyError) {}
      state.currencyOverride = '';
    }, 0);
  }

  function cloneCart(cart) {
    return cart ? JSON.parse(JSON.stringify(cart)) : { items: [], item_count: 0, total_price: 0 };
  }

  function normalizeProperties(properties) {
    var normalized = {};
    properties = properties || {};
    var keys = Object.keys(properties).sort();
    for (var i = 0; i < keys.length; i++) {
      if (properties[keys[i]] != null && properties[keys[i]] !== '') normalized[keys[i]] = String(properties[keys[i]]);
    }
    return normalized;
  }

  function propertiesMatch(first, second) {
    first = normalizeProperties(first);
    second = normalizeProperties(second);
    var firstKeys = Object.keys(first);
    var secondKeys = Object.keys(second);
    if (firstKeys.length !== secondKeys.length) return false;
    for (var i = 0; i < firstKeys.length; i++) {
      if (firstKeys[i] !== secondKeys[i] || first[firstKeys[i]] !== second[secondKeys[i]]) return false;
    }
    return true;
  }

  function sellingPlanId(item) {
    if (!item) return '';
    if (item.selling_plan) return String(item.selling_plan);
    var allocation = item.selling_plan_allocation;
    return allocation && allocation.selling_plan ? String(allocation.selling_plan.id || '') : '';
  }

  function normalizeOptionName(name, index) {
    name = String(name || '').trim();
    if (/colou?r/i.test(name)) return 'Colour';
    if (/size/i.test(name)) return 'Size';
    return name || 'Option ' + (index + 1);
  }

  function optionPairsFromElement(element) {
    if (!element || !element.getAttribute) return [];
    var values = parseJson(element.getAttribute('data-variant-options')) || [];
    var names = parseJson(element.getAttribute('data-option-names')) || [];
    var pairs = [];
    for (var i = 0; i < values.length; i++) {
      var value = values[i];
      if (value && typeof value === 'object') {
        if (value.value != null && String(value.value) !== 'Default Title') {
          pairs.push({ name: normalizeOptionName(value.name, i), value: String(value.value) });
        }
        continue;
      }
      if (value == null || String(value) === 'Default Title') continue;
      var optionName = names[i] && typeof names[i] === 'object' ? names[i].name : names[i];
      pairs.push({ name: normalizeOptionName(optionName, i), value: String(value) });
    }
    return pairs;
  }

  function findMatchingItem(cart, payload) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (String(item.variant_id || item.id) !== String(payload.id)) continue;
      if (!propertiesMatch(item.properties, payload.properties)) continue;
      if (sellingPlanId(item) !== String(payload.selling_plan || '')) continue;
      return item;
    }
    return null;
  }

  function restorePayloadFromItem(item) {
    var quantity = parseInt(item && item.quantity, 10) || 0;
    var id = item && String(item.variant_id || item.id || '');
    if (!id || quantity < 1) return null;
    var payload = { id: id, quantity: quantity };
    var properties = normalizeProperties(item.properties);
    var propertyKeys = Object.keys(properties);
    if (propertyKeys.length) payload.properties = properties;
    var sellingPlan = sellingPlanId(item);
    if (sellingPlan) payload.selling_plan = sellingPlan;
    return payload;
  }

  function buyNowSnapshotHasComplexLines(snapshot) {
    if (!snapshot || !snapshot.items) return false;
    for (var i = 0; i < snapshot.items.length; i++) {
      if (snapshot.items[i].selling_plan) return true;
      if (snapshot.items[i].properties && Object.keys(snapshot.items[i].properties).length) return true;
    }
    return false;
  }

  function buyNowSnapshotQuantities(snapshot) {
    var quantities = {};
    if (!snapshot || !snapshot.items) return quantities;
    for (var i = 0; i < snapshot.items.length; i++) {
      var item = snapshot.items[i];
      if (!item || item.selling_plan || item.properties && Object.keys(item.properties).length) continue;
      quantities[String(item.id)] = (quantities[String(item.id)] || 0) + (parseInt(item.quantity, 10) || 0);
    }
    return quantities;
  }

  function identityFromSnapshotItem(item) {
    return {
      id: String(item && item.id || ''),
      properties: normalizeProperties(item && item.properties),
      selling_plan: String(item && item.selling_plan || '')
    };
  }

  function cartWithSnapshotOrder(cart, snapshot) {
    if (!cart || !cart.items || !snapshot || !snapshot.items || !snapshot.items.length) return cart;
    var ordered = [];
    var used = [];
    for (var i = 0; i < snapshot.items.length; i++) {
      var identity = identityFromSnapshotItem(snapshot.items[i]);
      for (var j = 0; j < cart.items.length; j++) {
        if (used[j] || !itemMatchesIdentity(cart.items[j], identity)) continue;
        ordered.push(cart.items[j]);
        used[j] = true;
        break;
      }
    }
    if (!ordered.length) return cart;
    for (var k = 0; k < cart.items.length; k++) {
      if (!used[k]) ordered.push(cart.items[k]);
    }
    var sortedCart = cloneCart(cart);
    sortedCart.items = ordered;
    return sortedCart;
  }

  function displayCartFromBuyNowSnapshot(snapshot) {
    if (!snapshot || !snapshot.cart || !snapshot.cart.items) return null;
    return cartWithSnapshotOrder(cloneCart(snapshot.cart), snapshot);
  }

  function cartMatchesBuyNowSnapshot(cart, snapshot) {
    if (!snapshot || !snapshot.buyNow) return false;
    var items = visibleItems(cart);
    if (items.length !== 1) return false;
    var item = items[0];
    if (String(item.variant_id || item.id || '') !== String(snapshot.buyNow.id || '')) return false;
    if ((parseInt(item.quantity, 10) || 0) !== (parseInt(snapshot.buyNow.quantity, 10) || 1)) return false;
    if (Object.keys(normalizeProperties(item.properties)).length) return false;
    return sellingPlanId(item) === '';
  }

  function snapshotCartForBuyNow(payload) {
    payload = normalizePayload(payload);
    if (!payload.id) {
      state.checkoutNavigationStarted = true;
      return false;
    }
    try {
      if (!window.sessionStorage) {
        state.checkoutNavigationStarted = true;
        return false;
      }
      var cart = projectCart();
      var items = visibleItems(cart);
      var snapshotItems = [];
      for (var i = 0; i < items.length; i++) {
        var restorePayload = restorePayloadFromItem(items[i]);
        if (restorePayload) snapshotItems.push(restorePayload);
      }
      var snapshot = {
        createdAt: Date.now(),
        buyNow: {
          id: payload.id,
          quantity: payload.quantity
        },
        items: snapshotItems,
        cart: cloneCart(cart),
        note: cart && cart.note || '',
        attributes: cart && cart.attributes || {}
      };
      sessionStorage.setItem(buyNowSnapshotStorageKey, JSON.stringify(snapshot));
      state.checkoutNavigationStarted = true;
      return true;
    } catch (storageError) {
      state.checkoutNavigationStarted = true;
      return false;
    }
  }

  function readBuyNowSnapshot() {
    var raw;
    try {
      raw = window.sessionStorage && sessionStorage.getItem(buyNowSnapshotStorageKey);
    } catch (storageError) {
      return null;
    }
    var snapshot = parseJson(raw);
    if (!snapshot || !snapshot.buyNow || !snapshot.createdAt || Date.now() - snapshot.createdAt > buyNowSnapshotMaxAge) {
      clearBuyNowSnapshot();
      return null;
    }
    return snapshot;
  }

  function primeBuyNowSnapshotDisplay() {
    var snapshot = readBuyNowSnapshot();
    if (!snapshot || !state.cart || !cartMatchesBuyNowSnapshot(state.cart, snapshot)) return false;
    var displayCart = displayCartFromBuyNowSnapshot(snapshot);
    if (!displayCart) return false;
    state.pendingBuyNowRestore = {
      snapshot: snapshot,
      sourceCart: cloneCart(state.cart)
    };
    state.cart = displayCart;
    state.canonicalRevision++;
    return true;
  }

  function metadataRestoreBody(snapshot, seed) {
    var body = seed || {};
    body.note = snapshot && snapshot.note || '';
    body.attributes = snapshot && snapshot.attributes || {};
    return body;
  }

  function restoreSimpleBuyNowSnapshot(snapshot, currentCart) {
    var currentItem = visibleItems(currentCart)[0];
    var updates = {};
    var quantities = buyNowSnapshotQuantities(snapshot);
    var currentId = String(currentItem.variant_id || currentItem.id || '');
    if (quantities[currentId] != null) {
      updates[String(currentItem.key || currentId)] = quantities[currentId];
      delete quantities[currentId];
    } else {
      updates[String(currentItem.key || currentId)] = 0;
    }
    var ids = Object.keys(quantities);
    for (var i = 0; i < ids.length; i++) updates[ids[i]] = quantities[ids[i]];
    return requestJson('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(metadataRestoreBody(snapshot, { updates: updates }))
    });
  }

  function restoreComplexBuyNowSnapshot(snapshot) {
    return requestJson('cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    }).then(function () {
      if (!snapshot.items || !snapshot.items.length) return null;
      return requestJson('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: snapshot.items })
      });
    }).then(function () {
      return requestJson('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(metadataRestoreBody(snapshot))
      });
    });
  }

  function restorePendingBuyNowSnapshot(cart, providedSnapshot) {
    var snapshot = providedSnapshot || readBuyNowSnapshot();
    state.pendingBuyNowRestore = null;
    if (!snapshot) return Promise.resolve({ cart: cart, action: 'route-refresh' });
    if (!cartMatchesBuyNowSnapshot(cart, snapshot)) {
      clearBuyNowSnapshot();
      return Promise.resolve({ cart: cart, action: 'route-refresh' });
    }
    var restore = buyNowSnapshotHasComplexLines(snapshot)
      ? restoreComplexBuyNowSnapshot(snapshot)
      : restoreSimpleBuyNowSnapshot(snapshot, cart);
    return restore.then(function (restoredCart) {
      clearBuyNowSnapshot();
      return { cart: cartWithSnapshotOrder(restoredCart || cart, snapshot), action: 'buy-now-restore' };
    }, function (error) {
      clearBuyNowSnapshot();
      showToast({
        message: error && error.message || 'Unable to restore your cart. Please check your bag.',
        type: 'error',
        actionLabel: messages.viewCart,
        actionUrl: route('cart'),
        duration: 7000
      });
      return requestJson('cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (freshCart) { return { cart: freshCart, action: 'buy-now-restore-error' }; })
        .catch(function () { return { cart: cart, action: 'buy-now-restore-error' }; });
    });
  }

  function syntheticItem(pending) {
    var payload = pending.payload;
    var meta = payload.meta || {};
    var variantTitle = meta.variantTitle || '';
    var options = meta.options && meta.options.length ? meta.options : [];
    if (!options.length && variantTitle && variantTitle !== 'Default Title') {
      options.push({ name: normalizeOptionName(meta.variantLabel, 0), value: variantTitle });
    }
    return {
      key: pending.token,
      id: payload.id,
      variant_id: payload.id,
      product_id: meta.productId || 0,
      quantity: payload.quantity,
      product_title: meta.title || 'Item',
      title: meta.title || 'Item',
      variant_title: variantTitle,
      options_with_values: options,
      properties: payload.properties || {},
      selling_plan: payload.selling_plan || '',
      url: meta.url || route('cart'),
      image: meta.image || '',
      featured_image: meta.image ? { url: meta.image } : null,
      final_price: meta.price || 0,
      price: meta.price || 0,
      final_line_price: (meta.price || 0) * payload.quantity,
      original_line_price: (meta.price || 0) * payload.quantity
    };
  }

  function applyProjectedAdd(projected, pending) {
    var matching = findMatchingItem(projected, pending.payload);
    if (matching) {
      matching.quantity += pending.payload.quantity;
      matching.final_line_price += (Number(matching.final_price) || 0) * pending.payload.quantity;
      var matchingIndex = projected.items.indexOf(matching);
      if (matchingIndex > 0) projected.items.splice(matchingIndex, 1);
      if (matchingIndex !== 0) projected.items.unshift(matching);
    } else {
      projected.items.unshift(syntheticItem(pending));
    }
    projected.item_count = (parseInt(projected.item_count, 10) || 0) + pending.payload.quantity;
    projected.total_price = (Number(projected.total_price) || 0) + ((Number(pending.payload.meta.price) || 0) * pending.payload.quantity);
  }

  function applyProjectedChange(projected, change) {
    var itemIndex = -1;
    for (var i = 0; i < projected.items.length; i++) {
      if (projected.items[i].key === change.key) {
        itemIndex = i;
        break;
      }
    }
    if (itemIndex === -1 && change.identity) {
      var matchingItem = findMatchingItem(projected, change.identity);
      if (matchingItem) itemIndex = projected.items.indexOf(matchingItem);
    }
    if (itemIndex === -1) return;
    var item = projected.items[itemIndex];
    var oldQuantity = parseInt(item.quantity, 10) || 0;
    var unitPrice = oldQuantity ? (Number(item.final_line_price) || 0) / oldQuantity : Number(item.final_price) || 0;
    projected.total_price = Math.max(0, Math.round((Number(projected.total_price) || 0) + ((change.desired - oldQuantity) * unitPrice)));
    projected.item_count = Math.max(0, (parseInt(projected.item_count, 10) || 0) + change.desired - oldQuantity);
    if (change.desired === 0) {
      projected.items.splice(itemIndex, 1);
    } else {
      item.quantity = change.desired;
      item.final_line_price = Math.max(0, Math.round(unitPrice * change.desired));
    }
  }

  function projectCart() {
    var projected = cloneCart(state.cart);
    if (!projected.items) projected.items = [];
    var operations = [];
    for (var i = 0; i < state.pendingAdds.length; i++) {
      if (state.pendingAdds[i].optimistic) operations.push({ type: 'add', sequence: state.pendingAdds[i].sequence, value: state.pendingAdds[i] });
    }
    var changeKeys = Object.keys(state.pendingChanges);
    for (var j = 0; j < changeKeys.length; j++) {
      var change = state.pendingChanges[changeKeys[j]];
      operations.push({ type: 'change', sequence: change.sequence, value: change });
    }
    operations.sort(function (first, second) { return first.sequence - second.sequence; });
    for (var k = 0; k < operations.length; k++) {
      if (operations[k].type === 'add') applyProjectedAdd(projected, operations[k].value);
      else if (operations[k].value.desired !== 0) applyProjectedChange(projected, operations[k].value);
    }

    return projected;
  }

  function activePendingAddCount() {
    var count = 0;
    for (var i = 0; i < state.pendingAdds.length; i++) {
      if (state.pendingAdds[i].source === 'drawer-recommendation') continue;
      if (!state.pendingAdds[i].confirmed) count++;
    }
    return count;
  }

  function localPendingMutationCount() {
    return Object.keys(state.pendingChanges).length + activePendingAddCount() + state.recommendationAddsInFlight;
  }

  function findItemByKey(cart, key) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].key || '') === String(key || '')) return cart.items[i];
    }
    return null;
  }

  function lineIdentity(item) {
    if (!item) return null;
    return {
      id: String(item.variant_id || item.id || ''),
      properties: normalizeProperties(item.properties),
      selling_plan: sellingPlanId(item)
    };
  }

  function itemMatchesIdentity(item, identity) {
    if (!item || !identity) return false;
    if (String(item.variant_id || item.id || '') !== String(identity.id || '')) return false;
    if (!propertiesMatch(item.properties, identity.properties)) return false;
    return sellingPlanId(item) === String(identity.selling_plan || '');
  }

  function findRecordItem(cart, record) {
    if (!record) return null;
    var keyedItem = findItemByKey(cart, record.key);
    if (keyedItem) return keyedItem;
    if (!cart || !cart.items || !record.identity) return null;
    var matchingItem = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (!itemMatchesIdentity(cart.items[i], record.identity)) continue;
      if (matchingItem) return null;
      matchingItem = cart.items[i];
    }
    return matchingItem;
  }

  function recordLineExists(cart, record) {
    if (findItemByKey(cart, record && record.key)) return true;
    if (!cart || !cart.items || !record || !record.identity) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (itemMatchesIdentity(cart.items[i], record.identity)) return true;
    }
    return false;
  }

  function setRecordKey(record, key) {
    key = String(key || '');
    if (!record || !key || record.key === key) return;
    if (state.pendingChanges[record.key] === record) delete state.pendingChanges[record.key];
    record.key = key;
    state.pendingChanges[key] = record;
  }

  function deletePendingChange(record) {
    var keys = Object.keys(state.pendingChanges);
    for (var i = 0; i < keys.length; i++) {
      if (state.pendingChanges[keys[i]] === record) delete state.pendingChanges[keys[i]];
    }
  }

  function rebasePendingChangeKeys(cart) {
    var keys = Object.keys(state.pendingChanges);
    for (var i = 0; i < keys.length; i++) {
      var record = state.pendingChanges[keys[i]];
      if (!record) continue;
      var item = findRecordItem(cart, record);
      if (item && item.key && !state.pendingChanges[String(item.key)]) setRecordKey(record, item.key);
    }
  }

  function maxQuantityForLine(cart, item) {
    if (!item) return null;
    var variantId = String(item.variant_id || item.id || '');
    var inventory = state.inventory[variantId];
    if (!inventory || !inventory.tracked) return null;
    var available = Math.max(parseInt(inventory.quantity, 10) || 0, 0);
    var usedByOtherLines = 0;
    for (var i = 0; cart && cart.items && i < cart.items.length; i++) {
      var other = cart.items[i];
      if (String(other.variant_id || other.id || '') === variantId && String(other.key || '') !== String(item.key || '')) {
        usedByOtherLines += parseInt(other.quantity, 10) || 0;
      }
    }
    return Math.max(available - usedByOtherLines, 0);
  }

  function updateCounts(cart) {
    var count = visibleItemCount(cart);
    var badge = document.getElementById('CartToggleItemCount');
    var total = document.getElementById('CartToggleItemCountTotal');
    var toggle = document.getElementById('cartTotal');
    var headings = document.querySelectorAll('.my-h3');
    if (badge) badge.textContent = count > 9 ? '9+' : count;
    if (total) total.value = count;
    if (toggle) toggle.classList.toggle('cartToggle--empty', count === 0);
    for (var i = 0; i < headings.length; i++) headings[i].textContent = 'My Bag (' + count + ')';
  }

  function drawerRowsMatch(items) {
    var container = document.getElementById('custom-cart-drawer-items');
    if (!container) return false;
    var rows = container.querySelectorAll('.cart-item');
    if (rows.length !== items.length) return false;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-cart-line-key') !== String(items[i].key || '')) return false;
    }
    return true;
  }

  function syncDrawer(cart) {
    if (!window.GlossyDrawer || !document.getElementById('custom-cart-drawer')) return false;
    var items = visibleItems(cart);
    if (!drawerRowsMatch(items)) {
      window.GlossyDrawer.render(cart);
    }

    var container = document.getElementById('custom-cart-drawer-items');
    var rows = container.querySelectorAll('.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var item = items[i];
      var input = rows[i].querySelector('.cart-item__quantity-input');
      var price = rows[i].querySelector('.cart-item__price:not(.cart-item__original-price)');
      rows[i].setAttribute('data-line-price', item.final_line_price);
      rows[i].setAttribute('data-line-quantity', item.quantity);
      if (input) {
        input.value = item.quantity;
        var maxQuantity = maxQuantityForLine(cart, item);
        if (maxQuantity == null) input.removeAttribute('max');
        else input.max = maxQuantity;
      }
      if (price) {
        price.innerHTML = formatMoney(item.final_line_price);
        stampMoney(price, item.final_line_price, cart);
      }

      var pendingLine = String(item.key || '').indexOf('pending-') === 0;
      var lineButtons = rows[i].querySelectorAll('[data-action]');
      for (var buttonIndex = 0; buttonIndex < lineButtons.length; buttonIndex++) {
        lineButtons[buttonIndex].disabled = pendingLine;
        lineButtons[buttonIndex].setAttribute('aria-disabled', pendingLine ? 'true' : 'false');
      }
    }

    var count = document.getElementById('cart-item-count');
    var subtotal = document.getElementById('custom-cart-subtotal');
    var checkout = document.getElementById('custom-cart-checkout-amount');
    var footer = document.querySelector('.custom-cart-drawer__footer');
    if (count) count.textContent = visibleItemCount(cart);
    if (subtotal) {
      subtotal.innerHTML = moneyMarkup(cart.total_price);
      stampMoney(subtotal, cart.total_price, cart);
    }
    if (checkout) {
      checkout.innerHTML = moneyMarkup(cart.total_price);
      stampMoney(checkout, cart.total_price, cart);
    }
    if (footer) footer.classList.toggle('is-hidden', items.length === 0);
    return true;
  }

  function lineSelector(key) {
    return '[data-cart-line-key="' + String(key).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]';
  }

  function syncCartPage(cart) {
    var page = document.querySelector('[data-glossy-cart-page]');
    if (!page) return;
    var itemMap = {};
    for (var i = 0; i < cart.items.length; i++) itemMap[cart.items[i].key] = cart.items[i];
    var lines = page.querySelectorAll('[data-cart-line-key]');
    for (var j = 0; j < lines.length; j++) {
      var key = lines[j].getAttribute('data-cart-line-key');
      var item = itemMap[key];
      lines[j].style.display = item ? '' : 'none';
      if (!item) continue;
      var input = lines[j].querySelector('.inputCounter');
      var unitPrice = lines[j].querySelector('[data-cart-unit-price]');
      var lineTotals = lines[j].querySelectorAll('[data-cart-final-line-price]');
      lines[j].setAttribute('data-line-price', item.final_line_price);
      lines[j].setAttribute('data-line-quantity', item.quantity);
      if (input) {
        input.value = item.quantity;
        var maxQuantity = maxQuantityForLine(cart, item);
        if (maxQuantity == null) input.removeAttribute('max');
        else input.max = maxQuantity;
      }
      if (unitPrice) {
        unitPrice.innerHTML = formatMoney(item.final_price);
        stampMoney(unitPrice, item.final_price, cart);
      }
      for (var lineTotalIndex = 0; lineTotalIndex < lineTotals.length; lineTotalIndex++) {
        lineTotals[lineTotalIndex].innerHTML = formatMoney(item.final_line_price);
        stampMoney(lineTotals[lineTotalIndex], item.final_line_price, cart);
      }
      var increase = lines[j].querySelector('[data-cart-action="increase"]');
      var lineMax = maxQuantityForLine(cart, item);
      if (increase) {
        increase.disabled = lineMax != null && item.quantity >= lineMax;
        increase.setAttribute('aria-disabled', increase.disabled ? 'true' : 'false');
      }
    }
    var totals = page.querySelectorAll('.cart-total-price__value');
    for (var k = 0; k < totals.length; k++) {
      totals[k].innerHTML = moneyMarkup(cart.total_price);
      stampMoney(totals[k], cart.total_price, cart);
    }
    page.setAttribute('data-cart-total-price', cart.total_price);
  }

  function syncCartProcessingInfo() {
    if (!document.querySelector('[data-glossy-cart-page]')) return;
    var sourceTemplate = document.querySelector('template[data-glossy-cart-processing-source]');
    var source = sourceTemplate && sourceTemplate.content ? sourceTemplate.content.querySelector('.process-main') : null;
    var targets = document.querySelectorAll('[data-glossy-cart-page] .checkout-buttons');
    for (var i = 0; i < targets.length; i++) {
      var existing = targets[i].querySelector('[data-glossy-cart-processing]');
      if (!state.cartProcessingVisible || !source) {
        if (existing) existing.remove();
        continue;
      }
      if (existing) continue;
      var wrapper = document.createElement('div');
      wrapper.className = 'shopify-section procu';
      wrapper.setAttribute('data-glossy-cart-processing', 'true');
      wrapper.appendChild(source.cloneNode(true));
      targets[i].appendChild(wrapper);
    }
  }

  function setControlPending(control, pendingClass, pending) {
    if (!control) return;
    if (pending) {
      var alreadyPending = control.classList.contains('glossy-cart-checkout-pending') || control.classList.contains('glossy-cart-express-pending');
      if (!alreadyPending) {
        control.setAttribute('data-glossy-cart-previous-aria-disabled', control.getAttribute('aria-disabled') == null ? '__missing__' : control.getAttribute('aria-disabled'));
        control.setAttribute('data-glossy-cart-previous-aria-busy', control.getAttribute('aria-busy') == null ? '__missing__' : control.getAttribute('aria-busy'));
      }
      control.classList.add(pendingClass);
      control.setAttribute('aria-busy', 'true');
      control.setAttribute('aria-disabled', 'true');
    } else if (control.classList.contains('glossy-cart-checkout-pending') || control.classList.contains('glossy-cart-express-pending')) {
      control.classList.remove('glossy-cart-checkout-pending');
      control.classList.remove('glossy-cart-express-pending');
      var previousDisabled = control.getAttribute('data-glossy-cart-previous-aria-disabled');
      var previousBusy = control.getAttribute('data-glossy-cart-previous-aria-busy');
      if (previousDisabled === '__missing__') control.removeAttribute('aria-disabled');
      else control.setAttribute('aria-disabled', previousDisabled);
      if (previousBusy === '__missing__') control.removeAttribute('aria-busy');
      else control.setAttribute('aria-busy', previousBusy);
      control.removeAttribute('data-glossy-cart-previous-aria-disabled');
      control.removeAttribute('data-glossy-cart-previous-aria-busy');
    }
  }

  // Express/dynamic buttons (Shop Pay, Google Pay, Buy-it-Now) cannot be deferred and
  // replayed, so they are dimmed and blocked for the whole duration of any local mutation.
  function applyExpressPending(pending) {
    var controls = document.querySelectorAll(expressCheckoutSelector);
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      if (pending) {
        var parentExpress = control.parentElement && control.parentElement.closest ? control.parentElement.closest(expressCheckoutSelector) : null;
        if (parentExpress) continue;
      }
      setControlPending(control, 'glossy-cart-express-pending', pending);
    }
  }

  // The regular checkout button only shows its spinner if the customer actually clicks it
  // while a mutation is still settling (see queueCheckout/proceedQueuedCheckout).
  function setRegularCheckoutSpinner(control, pending) {
    setControlPending(control, 'glossy-cart-checkout-pending', pending);
  }

  function queueCheckout(control) {
    if (!control) return;
    var href = control.getAttribute && control.getAttribute('href') || '';
    state.checkoutNavigationStarted = false;
    state.queuedCheckout = { control: control, href: href };
    setRegularCheckoutSpinner(control, true);
  }

  function proceedQueuedCheckout() {
    var queued = state.queuedCheckout;
    if (!queued) return;
    state.queuedCheckout = null;
    var destination = queued.href || route('checkout');
    var control = queued.control;
    if (!control || !document.contains(control)) {
      var page = document.querySelector('[data-glossy-cart-page]');
      control = (page && page.querySelector('.cart__checkout, [name="checkout"]')) ||
        document.querySelector('.custom-cart-drawer__checkout, .cart__checkout, [name="checkout"]');
    }
    if (control) {
      setRegularCheckoutSpinner(control, false);
      state.checkoutNavigationStarted = true;
      try {
        if (control.tagName === 'A' && control.getAttribute('href')) {
          window.location.href = control.getAttribute('href');
        } else {
          control.click();
        }
        return;
      } catch (checkoutError) {
        window.location.href = destination;
      }
      return;
    }
    state.checkoutNavigationStarted = true;
    window.location.href = destination;
  }

  function renderProjection() {
    var projected = projectCart();
    if (state.checkoutNavigationStarted) return projected;
    if (state.queuedCheckout && pendingMutationCount() === 0) {
      proceedQueuedCheckout();
      return projected;
    }
    try { syncDrawer(projected); } catch (drawerError) {}
    try { syncCartPage(projected); } catch (cartPageError) {}
    try { updateCounts(projected); } catch (countError) {}
    try { convertActiveCurrency(); } catch (currencyError) {}
    try { setLineControlsPending(Object.keys(state.pendingChanges).length > 0); } catch (lineControlError) {}
    try { applyExpressPending(pendingMutationCount() > 0); } catch (checkoutError) {}
    return projected;
  }

  function showToast(options, legacyType, legacyDuration) {
    if (typeof options === 'string') options = { message: options, type: legacyType, duration: legacyDuration };
    options = options || {};
    var hasAction = options.actionLabel && options.actionUrl;
    var openDrawer = document.querySelector('#custom-cart-drawer.is-open');
    if (!hasAction && openDrawer && window.GlossyDrawer && window.GlossyDrawer.showToast) {
      window.GlossyDrawer.showToast(options.message || '', options.type || 'error', options.duration);
      return true;
    }
    var toast = document.getElementById('glossy-cart-global-toast');
    if (!toast) return false;
    var message = toast.querySelector('[data-glossy-toast-message]');
    var action = toast.querySelector('[data-glossy-toast-action]');
    if (state.toastTimer) clearTimeout(state.toastTimer);
    if (message) message.textContent = options.message || '';
    if (action) {
      if (hasAction) {
        action.textContent = options.actionLabel;
        action.href = options.actionUrl;
        action.hidden = false;
      } else {
        action.hidden = true;
      }
    }
    toast.className = 'glossy-cart-global-toast is-' + (options.type || 'error') + ' is-visible';
    toast.setAttribute('role', options.type === 'error' ? 'alert' : 'status');
    toast.setAttribute('aria-live', options.type === 'error' ? 'assertive' : 'polite');
    var duration = options.duration == null ? 5000 : options.duration;
    if (duration > 0) state.toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, duration);
    return true;
  }

  function markTrigger(trigger, pending) {
    if (!trigger || !trigger.setAttribute) return;
    if (pending) {
      trigger.setAttribute('data-glossy-cart-pending', 'true');
      trigger.setAttribute('aria-busy', 'true');
    } else {
      trigger.removeAttribute('data-glossy-cart-pending');
      trigger.removeAttribute('aria-busy');
    }
  }

  function getCart(options) {
    options = options || {};
    if (state.cart && !options.force) return Promise.resolve(state.cart);
    if (state.cartRequest) {
      if (options.force && (state.cartRequestEpoch !== state.mutationEpoch || state.cartRequestRevision !== state.canonicalRevision)) {
        return state.cartRequest.then(function () { return getCart({ force: true }); }, function () { return getCart({ force: true }); });
      }
      return state.cartRequest;
    }
    var requestEpoch = state.mutationEpoch;
    var requestRevision = state.canonicalRevision;
    state.cartRequestEpoch = requestEpoch;
    state.cartRequestRevision = requestRevision;
    state.cartRequest = requestJson('cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (cart) {
        state.cartRequest = null;
        state.cartRequestEpoch = null;
        state.cartRequestRevision = null;
        if (requestEpoch === state.mutationEpoch && requestRevision === state.canonicalRevision) {
          removeConfirmedRecommendationAdds();
          state.cart = cart;
          renderProjection();
          return cart;
        }
        return state.cart || cart;
      }, function (error) {
        state.cartRequest = null;
        state.cartRequestEpoch = null;
        state.cartRequestRevision = null;
        throw error;
      });
    return state.cartRequest;
  }

  function reconcileCart() {
    var requestEpoch = state.mutationEpoch;
    var requestRevision = state.canonicalRevision;
    return requestJson('?sections=glossy-cart-state', { headers: { 'Accept': 'application/json' } })
      .then(function (sections) {
        var canonical = stateFromSection(sections && sections['glossy-cart-state']);
        if (!canonical) throw createCartError(null, { description: messages.updateError });
        if (requestEpoch === state.mutationEpoch && requestRevision === state.canonicalRevision) {
          removeConfirmedRecommendationAdds();
          state.cart = canonical.cart;
          state.inventory = canonical.inventory;
          state.canonicalRevision++;
          renderProjection();
          return state.cart;
        }
        return state.cart || canonical.cart;
      })
      .catch(function () { return getCart({ force: true }); });
  }

  function cartPageRowsMatch(cart) {
    var page = document.querySelector('[data-glossy-cart-page]');
    if (!page) return true;
    var items = cart && cart.items || [];
    var lines = page.querySelectorAll('[data-cart-line-key]');
    var cartKeys = {};
    var renderedKeys = {};
    for (var i = 0; i < items.length; i++) cartKeys[String(items[i].key || '')] = true;
    for (var j = 0; j < lines.length; j++) renderedKeys[lines[j].getAttribute('data-cart-line-key') || ''] = true;
    var cartKeyList = Object.keys(cartKeys);
    var renderedKeyList = Object.keys(renderedKeys);
    if (cartKeyList.length !== renderedKeyList.length) return false;
    for (var k = 0; k < cartKeyList.length; k++) {
      if (!renderedKeys[cartKeyList[k]]) return false;
    }
    return true;
  }

  function refreshCartOnRoute() {
    var recentAddTime = readRecentAddTime();

    function applyRouteCart(cart, action) {
      if (localPendingMutationCount() > 0) return Promise.resolve(state.cart);
      var needsSectionRefresh = !cartPageRowsMatch(cart);
      removeConfirmedRecommendationAdds();
      state.cart = cart;
      state.canonicalRevision++;
      var projected = renderProjection();
      if (window.GlossyDrawer) setTimeout(function () { window.GlossyDrawer.refreshRecommendations(projected); }, 0);
      dispatch('glossy:cart:updated', { action: action, cart: state.cart });
      if (!needsSectionRefresh || !document.querySelector('[data-glossy-cart-page]')) return Promise.resolve(state.cart);
      return requestCartPageSnapshot().then(function (snapshot) {
        if (localPendingMutationCount() > 0) return state.cart;
        removeConfirmedRecommendationAdds();
        state.cart = snapshot.cart;
        state.inventory = snapshot.inventory || state.inventory;
        state.canonicalRevision++;
        if (snapshot.cartPageSection) replaceCartPageSection(snapshot.cartPageSection);
        renderProjection();
        return state.cart;
      }).catch(function () { return state.cart; });
    }

    var pendingBuyNowRestore = state.pendingBuyNowRestore;
    var initialRefresh = pendingBuyNowRestore
      ? restorePendingBuyNowSnapshot(pendingBuyNowRestore.sourceCart, pendingBuyNowRestore.snapshot)
        .then(function (result) { return applyRouteCart(result.cart, result.action || 'route-refresh'); })
        .catch(function () { return state.cart; })
      : requestJson('cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(restorePendingBuyNowSnapshot)
        .then(function (result) { return applyRouteCart(result.cart, result.action || 'route-refresh'); })
        .catch(function () { return state.cart; });

    if (recentAddTime) {
      initialRefresh.then(function () {
        if (state.recentAddRecheckTimer) clearTimeout(state.recentAddRecheckTimer);
        state.recentAddRecheckTimer = setTimeout(function () {
          state.recentAddRecheckTimer = null;
          requestJson('cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
            .then(function (cart) { return applyRouteCart(cart, 'route-recheck'); })
            .then(clearRecentAdd, clearRecentAdd);
        }, 1500);
      });
    }
    return initialRefresh;
  }

  function normalizePayload(payload) {
    payload = payload || {};
    var quantity = parseInt(payload.quantity, 10);
    return {
      id: String(payload.id || ''),
      quantity: quantity > 0 ? quantity : 1,
      properties: normalizeProperties(payload.properties),
      selling_plan: payload.selling_plan || '',
      meta: payload.meta || {}
    };
  }

  function fieldValue(form, selector) {
    var field = form && form.querySelector(selector);
    return field ? field.value : '';
  }

  function inferMeta(form, trigger) {
    var scope = trigger && trigger.closest ? trigger.closest('.cart-rec-item, [data-product-card], .pdcs-item, .product-block, .product-details, .productForm, .product-single') : null;
    if (!scope) scope = form || document;
    var selected = form && form.querySelector('input[data-variant-id]:checked');
    var image = scope.querySelector && scope.querySelector('img');
    var title = scope.querySelector && scope.querySelector('[data-product-title], .cart-rec-item__title, .pdcs-title, .product-block__title, .product-title, h1, h2, h3, h4');
    var link = scope.querySelector && scope.querySelector('a[href*="/products/"]');
    if (!image) image = document.querySelector('.product-main-image img, .product-single__photo img, main img');
    if (!title) title = document.querySelector('h1, [data-product-title], .product-title');
    var idField = form && form.querySelector('[name="id"]');
    var selectedOption = idField && idField.options ? idField.options[idField.selectedIndex] : null;
    var optionSource = selected || selectedOption || trigger;
    var options = optionPairsFromElement(optionSource);
    var price = trigger && trigger.getAttribute('data-variant-price') || selected && selected.getAttribute('data-variant-price') || selectedOption && selectedOption.getAttribute('data-variant-price') || form && form.getAttribute('data-product-price') || '';
    return {
      title: trigger && trigger.getAttribute('data-product-title') || form && form.getAttribute('data-product-title') || scope.getAttribute && scope.getAttribute('data-product-title') || title && title.textContent.trim() || 'Item',
      variantTitle: selected && (selected.getAttribute('data-variant-title') || selected.value) || trigger && trigger.getAttribute('data-variant-title') || '',
      variantLabel: normalizeOptionName(selected && selected.getAttribute('name'), 0),
      options: options,
      image: trigger && trigger.getAttribute('data-product-image') || form && form.getAttribute('data-product-image') || scope.getAttribute && scope.getAttribute('data-product-image') || image && (image.currentSrc || image.src) || '',
      url: trigger && trigger.getAttribute('data-product-url') || form && form.getAttribute('data-product-url') || scope.getAttribute && scope.getAttribute('data-product-url') || link && link.href || window.location.pathname,
      productId: parseInt(form && form.getAttribute('data-product-id') || scope.getAttribute && scope.getAttribute('data-product-id'), 10) || 0,
      price: parseInt(price, 10) || 0
    };
  }

  function payloadFromForm(form, trigger) {
    var clickedId = trigger && (trigger.getAttribute('data-variant-id') || (trigger.getAttribute('name') === 'id' ? trigger.value : ''));
    var id = clickedId || fieldValue(form, '[name="id"]') || fieldValue(form, '[name="variant-id"]');
    var quantity = parseInt(fieldValue(form, '[name="quantity"]'), 10) || 1;
    var properties = {};
    var fields = form ? form.querySelectorAll('[name^="properties["]') : [];
    for (var i = 0; i < fields.length; i++) {
      if ((fields[i].type === 'checkbox' || fields[i].type === 'radio') && !fields[i].checked) continue;
      var match = fields[i].name.match(/^properties\[(.*)\]$/);
      if (match && fields[i].value) properties[match[1]] = fields[i].value;
    }
    return normalizePayload({
      id: id,
      quantity: quantity,
      properties: properties,
      selling_plan: fieldValue(form, '[name="selling_plan"]'),
      meta: inferMeta(form, trigger)
    });
  }

  function removePendingAdd(token) {
    for (var i = 0; i < state.pendingAdds.length; i++) {
      if (state.pendingAdds[i].token === token) {
        state.pendingAdds.splice(i, 1);
        return;
      }
    }
  }

  function removeConfirmedRecommendationAdds() {
    var removed = false;
    for (var i = state.pendingAdds.length - 1; i >= 0; i--) {
      if (state.pendingAdds[i].source === 'drawer-recommendation' && state.pendingAdds[i].confirmed) {
        state.pendingAdds.splice(i, 1);
        removed = true;
      }
    }
    return removed;
  }

  function shouldOptimisticallyAdd(options) {
    if (options.optimistic != null) return options.optimistic === true;
    var source = options.source || '';
    var productSources = ['pdp', 'homepage-product-card', 'legacy-product-form', 'legacy-gift-card', 'legacy-product-desktop', 'legacy-product-mobile'];
    if (productSources.indexOf(source) !== -1) return true;
    var body = document.body;
    var onProductPage = body && body.classList && body.classList.contains('template-product');
    return !!(onProductPage && (source === 'product-form' || source === 'form-submit' || source === 'shop-js'));
  }

  function refreshAfterRecommendationAdds() {
    if (state.checkoutNavigationStarted) return Promise.resolve(state.cart);
    if (state.recommendationAddsInFlight > 0) return Promise.resolve(state.cart);
    if (state.recommendationRefreshRequest) return state.recommendationRefreshRequest;
    var refreshWave = state.recommendationWave;
    state.recommendationRefreshRequest = requestJson('cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (cart) {
        removeConfirmedRecommendationAdds();
        state.cart = cart;
        state.canonicalRevision++;
        rebasePendingChangeKeys(state.cart);
        clearPendingRecommendationItems();
        var projected = renderProjection();
        if (window.GlossyDrawer) setTimeout(function () { window.GlossyDrawer.refreshRecommendations(projected); }, 0);
        return state.cart;
      })
      .catch(function () { return state.cart; })
      .then(function (cart) {
        state.recommendationRefreshRequest = null;
        if (state.recommendationAddsInFlight === 0 && state.recommendationWave !== refreshWave) return refreshAfterRecommendationAdds();
        return cart;
      });
    return state.recommendationRefreshRequest;
  }

  function setRecommendationItemPending(trigger, pending) {
    var item = trigger && trigger.closest ? trigger.closest('.cart-rec-item') : null;
    if (!item) return;
    if (pending) {
      if (!item.getAttribute('data-pending-recommendation-index') && item.parentNode) {
        var siblings = item.parentNode.querySelectorAll('.cart-rec-item');
        for (var index = 0; index < siblings.length; index++) {
          if (siblings[index] === item) {
            item.setAttribute('data-pending-recommendation-index', index);
            break;
          }
        }
      }
      item.classList.add('is-pending');
      item.setAttribute('aria-busy', 'true');
    } else {
      item.classList.remove('is-pending');
      item.removeAttribute('aria-busy');
      item.removeAttribute('data-pending-recommendation-index');
    }
  }

  function clearPendingRecommendationItems() {
    var pendingItems = document.querySelectorAll('#cart-recommendations-items .cart-rec-item.is-pending');
    for (var i = 0; i < pendingItems.length; i++) {
      if (pendingItems[i].parentNode) pendingItems[i].parentNode.removeChild(pendingItems[i]);
    }
  }

  function addRecommendation(payload, trigger) {
    payload = normalizePayload(payload);
    if (!payload.id) {
      var selectionError = createCartError(null, { description: messages.selectVariant });
      showToast({ message: messages.selectVariant, type: 'error' });
      return Promise.reject(selectionError);
    }
    if (trigger && trigger.getAttribute('data-glossy-cart-pending') === 'true') return Promise.resolve(null);
    if (window.navigator && navigator.onLine === false) {
      var offlineError = createCartError(null, { description: messages.offline });
      showToast({ message: messages.offline, type: 'error' });
      return Promise.reject(offlineError);
    }

    var sequence = ++state.pendingSequence;
    var token = 'pending-rec-' + sequence;
    var pendingAdd = { token: token, sequence: sequence, payload: payload, optimistic: true, source: 'drawer-recommendation', confirmed: false };
    state.pendingAdds.push(pendingAdd);
    markRecentAdd();
    state.recommendationAddsInFlight++;
    state.recommendationWave++;
    state.mutationEpoch++;
    markTrigger(trigger, true);
    if (trigger) { trigger.classList.add('is-loading'); trigger.disabled = true; }
    setRecommendationItemPending(trigger, true);
    var projected = renderProjection();
    if (window.GlossyDrawer) setTimeout(function () { window.GlossyDrawer.refreshRecommendations(projected); }, 0);
    dispatch('glossy:cart:pending', { action: 'add', payload: payload, source: 'drawer-recommendation' });

    var released = false;
    var timedOut = false;
    function release(removeOptimistic) {
      if (released) return false;
      released = true;
      state.recommendationAddsInFlight = Math.max(0, state.recommendationAddsInFlight - 1);
      markTrigger(trigger, false);
      if (trigger) { trigger.classList.remove('is-loading'); trigger.disabled = false; }
      if (removeOptimistic) {
        removePendingAdd(token);
        setRecommendationItemPending(trigger, false);
      }
      var releasedProjection = renderProjection();
      if (!state.checkoutNavigationStarted && window.GlossyDrawer) setTimeout(function () { window.GlossyDrawer.refreshRecommendations(releasedProjection); }, 0);
      return true;
    }

    var timeout = setTimeout(function () {
      timedOut = true;
      release(true);
      if (!state.checkoutNavigationStarted) {
        showMutationTimeoutWarning();
        refreshAfterRecommendationAdds();
      }
    }, 15000);

    return requestJson('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: payload.id, quantity: payload.quantity }),
      keepalive: true
    }).then(function (response) {
      clearTimeout(timeout);
      pendingAdd.confirmed = true;
      release(false);
      dispatch('glossy:cart:updated', { action: 'add', cart: projectCart(), source: 'drawer-recommendation' });
      if (state.checkoutNavigationStarted) return { item: response, cart: state.cart };
      return refreshAfterRecommendationAdds().then(function (cart) { return { item: response, cart: cart }; });
    }, function (error) {
      clearTimeout(timeout);
      release(true);
      if (!state.checkoutNavigationStarted && !timedOut) showToast({ message: error && error.message || messages.addError, type: 'error' });
      dispatch('glossy:cart:error', { action: 'add', error: error, payload: payload });
      if (!state.checkoutNavigationStarted) refreshAfterRecommendationAdds();
      throw error;
    });
  }

  function add(payload, options) {
    payload = normalizePayload(payload);
    options = options || {};
    var trigger = options.trigger || null;
    if (!payload.id) {
      var selectionError = createCartError(null, { description: messages.selectVariant });
      showToast({ message: messages.selectVariant, type: 'error' });
      return Promise.reject(selectionError);
    }
    if (trigger && trigger.getAttribute('data-glossy-cart-pending') === 'true') return Promise.resolve(null);
    if (window.navigator && navigator.onLine === false) {
      var offlineError = createCartError(null, { description: messages.offline });
      showToast({ message: messages.offline, type: 'error' });
      return Promise.reject(offlineError);
    }

    var sequence = ++state.pendingSequence;
    state.mutationEpoch++;
    var token = 'pending-' + sequence;
    var optimistic = shouldOptimisticallyAdd(options);
    var pendingAdd = { token: token, sequence: sequence, payload: payload, optimistic: optimistic, source: options.source || 'unknown' };
    state.pendingAdds.push(pendingAdd);
    if (document.querySelector('[data-glossy-cart-page]')) {
      state.cartProcessingVisible = true;
      syncCartProcessingInfo();
    }
    markTrigger(trigger, true);
    var drawerOpened = false;
    if (optimistic && options.openDrawer !== false && window.GlossyDrawer) {
      try {
        window.GlossyDrawer.open();
        drawerOpened = !!document.querySelector('#custom-cart-drawer.is-open');
      } catch (drawerError) {}
    }
    renderProjection();
    markRecentAdd();
    dispatch('glossy:cart:pending', { action: 'add', payload: payload, source: options.source || 'unknown' });

    var item = { id: payload.id, quantity: payload.quantity };
    if (Object.keys(payload.properties).length) item.properties = payload.properties;
    if (payload.selling_plan) item.selling_plan = payload.selling_plan;
    var requestBody = {
      items: [item],
      sections: ['glossy-cart-state'],
      sections_url: window.location.pathname
    };

    var addedResponse = null;
    var checkoutOnlyResult = false;
    var released = false;
    var timedOut = false;
    function release(shouldRender) {
      if (released) return false;
      released = true;
      removePendingAdd(token);
      markTrigger(trigger, false);
      if (shouldRender !== false) renderProjection();
      return true;
    }
    var timeout = setTimeout(function () {
      timedOut = true;
      release();
      if (!state.checkoutNavigationStarted) {
        showMutationTimeoutWarning();
        reconcileCart().catch(function () {});
      }
    }, 15000);

    return requestJson('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(requestBody),
      keepalive: true
    }).then(function (response) {
      addedResponse = response;
      if (state.queuedCheckout || state.checkoutNavigationStarted) {
        checkoutOnlyResult = true;
        clearTimeout(timeout);
        release();
        return state.cart;
      }
      var canonical = response.sections && stateFromSection(response.sections['glossy-cart-state']);
      if (canonical) {
        state.inventory = canonical.inventory;
        return canonical.cart;
      }
      return getCart({ force: true });
    }).then(function (cart) {
      clearTimeout(timeout);
      var checkoutPending = state.queuedCheckout || state.checkoutNavigationStarted;
      release(!!checkoutPending);
      if (checkoutOnlyResult || checkoutPending || state.checkoutNavigationStarted) {
        dispatch('glossy:cart:updated', { action: 'add', cart: cart || state.cart, source: options.source || 'unknown' });
        return { item: addedResponse, cart: cart || state.cart };
      }
      removeConfirmedRecommendationAdds();
      state.cart = cart;
      state.canonicalRevision++;
      renderProjection();
      if (window.GlossyDrawer) setTimeout(function () { window.GlossyDrawer.refreshRecommendations(cart); }, 0);
      if (!optimistic && options.openDrawer !== false && window.GlossyDrawer) {
        try {
          window.GlossyDrawer.open();
          drawerOpened = !!document.querySelector('#custom-cart-drawer.is-open');
        } catch (drawerError) {}
      }
      var drawer = document.getElementById('custom-cart-drawer');
      var drawerIsOpen = drawer && drawer.classList.contains('is-open');
      if (options.openDrawer !== false && !drawerOpened && !drawerIsOpen) {
        showToast({ message: messages.added, type: 'success', actionLabel: messages.viewCart, actionUrl: route('cart') });
      }
      dispatch('glossy:cart:updated', { action: 'add', cart: cart, source: options.source || 'unknown' });
      return { item: addedResponse, cart: cart };
    }).catch(function (error) {
      clearTimeout(timeout);
      release();
      if (state.checkoutNavigationStarted) {
        dispatch('glossy:cart:error', { action: 'add', error: error, payload: payload });
        throw error;
      }
      return reconcileCart().catch(function () { return state.cart; }).then(function (cart) {
        if (cart) {
          removeConfirmedRecommendationAdds();
          state.cart = cart;
        }
        renderProjection();
        if (!timedOut) showToast({ message: error && error.message || messages.addError, type: 'error' });
        dispatch('glossy:cart:error', { action: 'add', error: error, payload: payload });
        throw error;
      });
    });
  }

  function addFromForm(form, options) {
    if (!form) return Promise.reject(createCartError(null, { description: messages.selectVariant }));
    options = options || {};
    return add(payloadFromForm(form, options.trigger), options);
  }

  function cartPageState() {
    var page = document.querySelector('[data-glossy-cart-page]');
    if (!page) return null;
    var activeLine = document.activeElement && document.activeElement.closest ? document.activeElement.closest('[data-cart-line-key]') : null;
    return {
      note: (page.querySelector('[name="note"]') || {}).value || '',
      accepted: !!(page.querySelector('[data-cart-acceptance-checkbox]') || {}).checked,
      focusKey: activeLine ? activeLine.getAttribute('data-cart-line-key') : '',
      focusAction: document.activeElement && document.activeElement.getAttribute ? document.activeElement.getAttribute('data-cart-action') || '' : ''
    };
  }

  function replaceCartPageSection(html) {
    if (!html) return false;
    var current = document.getElementById('shopify-section-main-custom-cart');
    if (!current) return false;
    var saved = cartPageState();
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var incoming = holder.querySelector('#shopify-section-main-custom-cart');
    if (!incoming) {
      var inner = holder.querySelector('[data-glossy-cart-page]');
      if (!inner) return false;
      current.innerHTML = '';
      current.appendChild(inner);
    } else {
      current.parentNode.replaceChild(incoming, current);
    }
    var page = document.querySelector('[data-glossy-cart-page]');
    if (page && saved) {
      var note = page.querySelector('[name="note"]');
      var accepted = page.querySelector('[data-cart-acceptance-checkbox]');
      if (note) note.value = saved.note;
      if (accepted) accepted.checked = saved.accepted;
      if (saved.focusKey) {
        var line = page.querySelector(lineSelector(saved.focusKey));
        var focusTarget = line && (saved.focusAction ? line.querySelector('[data-cart-action="' + saved.focusAction + '"]') : line.querySelector('button, input, a'));
        if (focusTarget) focusTarget.focus();
      }
    }
    if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
    if (window.Shopify && window.Shopify.StorefrontExpressButtons) window.Shopify.StorefrontExpressButtons.initialize();
    syncCartPage(state.cart);
    syncCartProcessingInfo();
    applyExpressPending(pendingMutationCount() > 0);
    updateCounts(state.cart);
    convertActiveCurrency();
    return true;
  }

  function pendingMutationCount() {
    return localPendingMutationCount();
  }

  function requestCartPageSnapshot() {
    var path = '?sections=glossy-cart-state,main-custom-cart&sections_url=' + encodeURIComponent(window.location.pathname);
    return requestJson(path, { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (response) {
      var canonical = stateFromSection(response && response['glossy-cart-state']);
      if (!canonical) throw createCartError(null, { description: messages.updateError });
      if (!response['main-custom-cart']) throw createCartError(null, { description: messages.updateError });
      return {
        cart: canonical.cart,
        inventory: canonical.inventory,
        cartPageSection: response['main-custom-cart'] || ''
      };
    });
  }

  function settleCartPageSection() {
    if (state.checkoutNavigationStarted) return;
    if (Object.keys(state.pendingChanges).length === 0 && state.latestCartPageSection) {
      replaceCartPageSection(state.latestCartPageSection);
      state.latestCartPageSection = '';
    }
  }

  function setLineControlsPending(pending) {
    var controls = document.querySelectorAll('#custom-cart-drawer [data-action]');
    var cartPageControls = document.querySelectorAll('[data-glossy-cart-page] [data-cart-action]');
    var activeRecord = null;
    var keys = Object.keys(state.pendingChanges);
    if (keys.length) activeRecord = state.pendingChanges[keys[0]];
    var activeTrigger = activeRecord && activeRecord.trigger;
    for (var i = 0; i < controls.length; i++) {
      if (pending) {
        if (!controls[i].hasAttribute('data-glossy-line-previous-disabled')) {
          controls[i].setAttribute('data-glossy-line-previous-disabled', controls[i].disabled ? 'true' : 'false');
        }
        controls[i].disabled = true;
        controls[i].classList.add('is-disabled');
        controls[i].setAttribute('aria-disabled', 'true');
        controls[i].classList.toggle('is-loading', !!(activeTrigger && controls[i] === activeTrigger && activeRecord.desired !== 0));
      } else if (controls[i].hasAttribute('data-glossy-line-previous-disabled')) {
        var wasDisabled = controls[i].getAttribute('data-glossy-line-previous-disabled') === 'true';
        var action = controls[i].getAttribute('data-cart-action') || controls[i].getAttribute('data-action');
        if (action !== 'increase') controls[i].disabled = wasDisabled;
        controls[i].classList.remove('is-disabled');
        controls[i].classList.remove('is-loading');
        controls[i].setAttribute('aria-disabled', controls[i].disabled ? 'true' : 'false');
        controls[i].removeAttribute('data-glossy-line-previous-disabled');
      } else if (!pending) {
        controls[i].classList.remove('is-loading');
      }
    }
    var rows = document.querySelectorAll('#custom-cart-drawer [data-cart-line-key]');
    for (var j = 0; j < rows.length; j++) {
      var removing = pending && activeRecord && activeRecord.desired === 0 && rows[j].getAttribute('data-cart-line-key') === activeRecord.key;
      rows[j].classList.toggle('item-is-loading', !!removing);
    }
    var cartPageRows = document.querySelectorAll('[data-glossy-cart-page] [data-cart-line-key]');
    for (var cartRowIndex = 0; cartRowIndex < cartPageRows.length; cartRowIndex++) {
      cartPageRows[cartRowIndex].classList.remove('item-is-loading');
    }
    for (var cartControlIndex = 0; cartControlIndex < cartPageControls.length; cartControlIndex++) {
      cartPageControls[cartControlIndex].disabled = false;
      cartPageControls[cartControlIndex].classList.remove('is-disabled');
      cartPageControls[cartControlIndex].classList.remove('is-loading');
      cartPageControls[cartControlIndex].removeAttribute('aria-disabled');
      cartPageControls[cartControlIndex].removeAttribute('data-glossy-line-previous-disabled');
    }
  }

  function sendChange(record) {
    if (record.inFlight) return;
    record.inFlight = true;
    record.sentQuantity = record.desired;
    dispatch('glossy:cart:pending', { action: record.sentQuantity === 0 ? 'remove' : 'change', key: record.key, quantity: record.sentQuantity });

    var targetItem = findRecordItem(state.cart, record);
    if (!targetItem) {
      deletePendingChange(record);
      renderProjection();
      for (var missingIndex = 0; missingIndex < record.waiters.length; missingIndex++) record.waiters[missingIndex].reject(createCartError(null, { description: messages.updateError }));
      return;
    }
    setRecordKey(record, targetItem.key);
    var body = {
      id: record.key,
      quantity: record.sentQuantity,
      sections: ['glossy-cart-state'],
      sections_url: window.location.pathname
    };
    if (document.querySelector('[data-glossy-cart-page]')) body.sections.push('main-custom-cart');

    var released = false;
    function release() {
      if (released) return false;
      released = true;
      record.inFlight = false;
      deletePendingChange(record);
      renderProjection();
      return true;
    }
    record.timeout = setTimeout(function () {
      record.timedOut = true;
      release();
      for (var timeoutIndex = 0; timeoutIndex < record.waiters.length; timeoutIndex++) record.waiters[timeoutIndex].resolve(state.cart);
      if (!state.checkoutNavigationStarted) {
        showMutationTimeoutWarning();
        reconcileCart().catch(function () {});
      }
    }, 15000);

    requestJson('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (cart) {
      clearTimeout(record.timeout);
      if (cart.sections && cart.sections['main-custom-cart']) state.latestCartPageSection = cart.sections['main-custom-cart'];
      var canonical = cart.sections && stateFromSection(cart.sections['glossy-cart-state']);
      if (canonical) {
        removeConfirmedRecommendationAdds();
        state.cart = canonical.cart;
        state.inventory = canonical.inventory;
      } else {
        removeConfirmedRecommendationAdds();
        state.cart = cart;
      }
      state.canonicalRevision++;
      rebasePendingChangeKeys(state.cart);
      release();
      if (!state.checkoutNavigationStarted) {
        settleCartPageSection();
        if (window.GlossyDrawer) setTimeout(function () { window.GlossyDrawer.refreshRecommendations(state.cart); }, 0);
      }
      for (var i = 0; i < record.waiters.length; i++) record.waiters[i].resolve(state.cart);
      dispatch('glossy:cart:updated', { action: record.sentQuantity === 0 ? 'remove' : 'change', cart: state.cart, key: record.key });
    }).catch(function (error) {
      clearTimeout(record.timeout);
      release();
      if (state.checkoutNavigationStarted) {
        for (var checkoutErrorIndex = 0; checkoutErrorIndex < record.waiters.length; checkoutErrorIndex++) record.waiters[checkoutErrorIndex].reject(error);
        dispatch('glossy:cart:error', { action: 'change', error: error, key: record.key });
        return;
      }
      reconcileCart().catch(function () { return state.cart; }).then(function (cart) {
        if (cart) {
          removeConfirmedRecommendationAdds();
          state.cart = cart;
        }
        renderProjection();
        state.latestCartPageSection = '';
        if (record.sentQuantity === 0 && !recordLineExists(state.cart, record)) {
          settleCartPageSection();
          for (var removedIndex = 0; removedIndex < record.waiters.length; removedIndex++) record.waiters[removedIndex].resolve(state.cart);
          dispatch('glossy:cart:updated', { action: 'remove', cart: state.cart, key: record.key });
          return;
        }
        if (!record.timedOut) showToast({ message: error && error.message || messages.updateError, type: 'error', actionLabel: messages.viewCart, actionUrl: route('cart') });
        for (var i = 0; i < record.waiters.length; i++) record.waiters[i].reject(error);
        dispatch('glossy:cart:error', { action: 'change', error: error, key: record.key });
      });
    });
  }

  function change(args) {
    args = args || {};
    var key = String(args.key || '');
    var quantity = Math.max(parseInt(args.quantity, 10) || 0, 0);
    if (!key) return Promise.reject(createCartError(null, { description: messages.updateError }));
    if (window.navigator && navigator.onLine === false) {
      var offlineError = createCartError(null, { description: messages.offline });
      showToast({ message: messages.offline, type: 'error' });
      return Promise.reject(offlineError);
    }
    var projected = projectCart();
    if (Object.keys(state.pendingChanges).length > 0) return Promise.resolve(projected);
    var currentItem = findItemByKey(projected, key);
    var currentQuantity = currentItem ? parseInt(currentItem.quantity, 10) || 0 : 0;
    if (!currentItem) {
      if (quantity === 0) return Promise.resolve(projected);
      return Promise.reject(createCartError(null, { description: messages.updateError }));
    }
    var maxQuantity = maxQuantityForLine(projected, currentItem);
    if (quantity > currentQuantity && maxQuantity != null && quantity > maxQuantity) {
      showToast({ message: messages.maxAvailable, type: 'error' });
      return Promise.resolve(projected);
    }
    var record = { key: key, identity: lineIdentity(currentItem), desired: quantity, sequence: ++state.pendingSequence, sentQuantity: null, inFlight: false, timedOut: false, timeout: null, waiters: [], trigger: args.trigger || null };
    state.pendingChanges[key] = record;
    state.mutationEpoch++;
    var promise = new Promise(function (resolve, reject) { record.waiters.push({ resolve: resolve, reject: reject }); });
    if (document.querySelector('[data-glossy-cart-page]')) {
      state.cartProcessingVisible = true;
      syncCartProcessingInfo();
    }
    renderProjection();
    sendChange(record);
    return promise;
  }

  function remove(args) {
    args = args || {};
    args.quantity = 0;
    return change(args);
  }

  function closest(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function lineQuantity(line) {
    var input = line && line.querySelector('.cart-item__quantity-input, .inputCounter');
    return parseInt(input && input.value, 10) || 0;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var currencyOption = closest(target, '.doubly-nice-select .option[data-value]');
    if (currencyOption) {
      scheduleCartCurrencyRefresh(currencyOption.getAttribute('data-value'));
      return;
    }
    var checkout = closest(target, checkoutSelector);
    if (checkout && pendingMutationCount() > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var isExpressCheckout = checkout.matches && checkout.matches(expressCheckoutSelector);
      if (!isExpressCheckout) queueCheckout(checkout);
      return;
    }
    var actionButton = closest(target, '#custom-cart-drawer [data-action], [data-glossy-cart-page] [data-cart-action]');
    if (actionButton) {
      var line = closest(actionButton, '[data-cart-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-cart-line-key');
      var quantity = lineQuantity(line);
      var action = actionButton.getAttribute('data-cart-action') || actionButton.getAttribute('data-action');
      event.preventDefault();
      event.stopImmediatePropagation();
      if (action === 'increase') change({ key: key, quantity: quantity + 1, trigger: actionButton }).catch(function () {});
      if (action === 'decrease') change({ key: key, quantity: Math.max(quantity - 1, 0), trigger: actionButton }).catch(function () {});
      if (action === 'remove') remove({ key: key, trigger: actionButton }).catch(function () {});
      return;
    }

    var recommendationButton = closest(target, '[data-glossy-recommendation-add]');
    if (recommendationButton) {
      var recommendation = closest(recommendationButton, '.cart-rec-item');
      var select = recommendation && recommendation.querySelector('.cart-rec-item__variant-select');
      var selectedOption = select && select.options ? select.options[select.selectedIndex] : null;
      var recommendationMeta = inferMeta(recommendation, recommendationButton);
      if (selectedOption) {
        recommendationMeta.price = parseInt(selectedOption.getAttribute('data-variant-price'), 10) || recommendationMeta.price;
        recommendationMeta.variantTitle = selectedOption.getAttribute('data-variant-title') || selectedOption.textContent;
        recommendationMeta.options = optionPairsFromElement(selectedOption);
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      addRecommendation({ id: select && select.value, quantity: 1, meta: recommendationMeta }, recommendationButton).catch(function () {});
      return;
    }

    var addButton = closest(target, '[data-add-to-cart], .usf-add-to-cart-btn, .usf-preview--add-to-cart-btn');
    var addForm = addButton && closest(addButton, 'form');
    if (addButton && addForm) {
      event.preventDefault();
      event.stopImmediatePropagation();
      addFromForm(addForm, { trigger: addButton, source: 'product-form' }).catch(function () {});
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (closest(form, '[data-glossy-cart-page]') && pendingMutationCount() > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (!form.matches('form.productForm, form.pdcs-form, form.usf-add-to-cart, form[action$="/cart/add"], form[action*="/cart/add?"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addFromForm(form, { trigger: document.activeElement, source: form.matches('form.pdcs-form') ? 'homepage-product-card' : 'form-submit' }).catch(function () {});
  }, true);

  document.addEventListener('change', function (event) {
    var currencySelector = closest(event.target, 'select[name="doubly-currencies"]');
    if (currencySelector) {
      scheduleCartCurrencyRefresh(currencySelector.value);
      return;
    }
    var size = closest(event.target, 'input[name="Size"][data-variant-id]');
    if (!size) return;
    var quantity = document.getElementById('product-quantity');
    if (quantity) quantity.value = '1';
  }, true);

  function selectedPdpPayload() {
    var form = document.querySelector('form.productForm');
    var trigger = document.getElementById('add-to-cart-btn');
    return { form: form, trigger: trigger, payload: form ? payloadFromForm(form, trigger) : null };
  }

  window.handleAddToCart = function () {
    var selected = selectedPdpPayload();
    if (!selected.form || !selected.payload || !selected.payload.id) {
      showToast({ message: messages.selectVariant, type: 'error' });
      return Promise.resolve(null);
    }
    return add(selected.payload, { trigger: selected.trigger, source: 'pdp' }).catch(function () {});
  };

  window.uf_addCart = function (variantId) {
    var trigger = window.event && window.event.currentTarget;
    return add({ id: variantId, quantity: 1, meta: inferMeta(null, trigger) }, { trigger: trigger, source: 'legacy-quick-add' }).catch(function () {});
  };
  window.uf_addCartSlide = function (quantity) {
    var form = document.querySelector('form.productForm');
    var trigger = window.event && window.event.currentTarget;
    var payload = form ? payloadFromForm(form, trigger) : null;
    if (payload && quantity != null) payload.quantity = Math.max(parseInt(quantity, 10) || 1, 1);
    return payload ? add(payload, { trigger: trigger, source: 'legacy-product-form' }).catch(function () {}) : Promise.resolve(null);
  };
  window.uf_addCartSlideGiftCard = function () {
    var form = document.querySelector('form.productForm');
    return form ? addFromForm(form, { source: 'legacy-gift-card' }).catch(function () {}) : Promise.resolve(null);
  };
  window.uf_addCartMobile = function () {
    var selected = document.getElementById('mp_variant_id_selected');
    var trigger = window.event && window.event.currentTarget;
    return add({ id: selected && selected.value, quantity: 1, meta: inferMeta(null, trigger || selected) }, { trigger: trigger, source: 'legacy-mobile-quick-add' }).catch(function () {});
  };
  window.uf_addCartProductPageDesktop = function (productId) {
    var selected = document.querySelector('input[name="radio_size_' + productId + '"]:checked');
    var trigger = window.event && window.event.currentTarget;
    return add({ id: selected && selected.value, quantity: 1, meta: inferMeta(null, trigger || selected) }, { trigger: trigger, source: 'legacy-product-desktop' }).catch(function () {});
  };
  window.uf_addCartProductPageMobile = function (productId) {
    var selected = document.querySelector('.' + productId + '_ddlsize');
    var trigger = window.event && window.event.currentTarget;
    return add({ id: selected && selected.value, quantity: 1, meta: inferMeta(null, trigger || selected) }, { trigger: trigger, source: 'legacy-product-mobile' }).catch(function () {});
  };

  window.refreshCartDrawer = function () { return getCart({ force: true }); };
  if (typeof window.openCartDrawer !== 'function') {
    window.openCartDrawer = function () {
      if (window.GlossyDrawer) window.GlossyDrawer.open();
      else window.location.href = route('cart');
    };
  }
  window.refreshAndOpenCartDrawer = function () {
    if (window.GlossyDrawer) window.GlossyDrawer.open();
    renderProjection();
    return getCart({ force: true });
  };

  window.addEventListener('online', function () {
    if (document.querySelector('#custom-cart-drawer.is-open') || document.querySelector('[data-glossy-cart-page]')) getCart({ force: true }).catch(function () {});
  });
  window.addEventListener('focus', function () {
    if (document.querySelector('#custom-cart-drawer.is-open') || document.querySelector('[data-glossy-cart-page]')) getCart({ force: true }).catch(function () {});
  });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      state.checkoutNavigationStarted = false;
      refreshCartOnRoute();
    }
  });

  window.GlossyCart = {
    add: add,
    addFromForm: addFromForm,
    change: change,
    remove: remove,
    get: getCart,
    snapshotBuyNowCart: snapshotCartForBuyNow,
    showToast: showToast
  };

  if (typeof window.showToast !== 'function') {
    window.showToast = function (message, type, duration) { return showToast(message, type, duration); };
  }

  primeBuyNowSnapshotDisplay();

  if (state.cart) {
    updateCounts(state.cart);
    syncDrawer(state.cart);
    syncCartPage(state.cart);
    convertActiveCurrency();
    applyExpressPending(pendingMutationCount() > 0);
  }

  refreshCartOnRoute();
})();
